export default __webpack_public_path__ + "static/908-6ae20189f49b87b6bb2662345bd4ce26.gif";